import { createAsyncThunk } from '@reduxjs/toolkit';

import { buildSpendInsightsBody } from '../lib/buildSpendInsightsBody';

import type {
    SpendInsightsOrderBy,
    SpendInsightsRequestParams,
    SpendSupplierRowDto,
} from '../types/ReportSpendSummarySchema';
import type { ThunkConfig } from 'app/providers/StoreProvider/config/types';

export interface FetchSpendBySupplierParams extends SpendInsightsRequestParams {
    orderBy?: SpendInsightsOrderBy;
}

export const fetchSpendBySupplier = createAsyncThunk<
    SpendSupplierRowDto[],
    FetchSpendBySupplierParams,
    ThunkConfig<string>
>('reportSpendSummary/fetchSpendBySupplier', async (params, thunkApi) => {
    const { extra, rejectWithValue } = thunkApi;
    try {
        const { orderBy = '-total_spend', ...filters } = params;
        const response = await extra.api.post<{
            items: SpendSupplierRowDto[];
        }>(
            '/v1/reports/spend-insights/by-supplier',
            buildSpendInsightsBody(filters, { orderBy }),
        );
        return response.data.items ?? [];
    } catch {
        return rejectWithValue('error');
    }
});
